import { HttpInterceptorFn, HttpContext, HttpContextToken } from '@angular/common/http';

const APPLY_CUSTOM_HEADER = new HttpContextToken<boolean>(() => false);

export const landpageInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.context.get(APPLY_CUSTOM_HEADER)) {
        const modifiedReq = req.clone({
            setHeaders: { 'X-Product': 'HUB' }
        });
        return next(modifiedReq);
    }
    return next(req);
};


export function applyCustomHeader() {
    return new HttpContext().set(APPLY_CUSTOM_HEADER, true);
}
